import {
  Autocomplete,
  AutocompleteOption,
  AutocompleteProps,
  AutocompleteStrategyStreetAddress,
} from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { isLocal } from '~/client/config/appConfig';
import { Property } from '~/common/types/buildings';

import { PropertyAddress, BuildingId, rootStyles } from './PropertySelect.styled';

type Props = Omit<AutocompleteProps<Property>, 'getOptionLabel' | 'renderOption'>;

export const PropertySelect: FunctionComponent<Props> = (props) => (
  <Autocomplete
    css={rootStyles}
    id="property-select"
    placeholder="Search by address or building code..."
    inputProps={{ 'aria-label': 'Property selection' }}
    getOptionLabel={({ buildingId, address }) => `${address} - ${buildingId}`}
    strategy={AutocompleteStrategyStreetAddress}
    hideOptionsWhenEmpty={!isLocal} // Auto show results during dev for convenience
    filterDebounceMs={200}
    renderOption={(optionProps, { buildingId, propertyId, address }) => (
      <AutocompleteOption {...optionProps} key={propertyId}>
        <PropertyAddress>{address}</PropertyAddress>
        <BuildingId>{buildingId}</BuildingId>
      </AutocompleteOption>
    )}
    {...props}
  />
);
